import { CurrencyDescription, CURRENCY_DESCRIPTION } from './currency_descriptions';

export default class Currency {
  static get(currencyCode: string): CurrencyDescription {
    return CURRENCY_DESCRIPTION[currencyCode];
  }

  static get currencyCodes() {
    return Object.keys(CURRENCY_DESCRIPTION).sort((a, b) => {
      return CURRENCY_DESCRIPTION[a].order - CURRENCY_DESCRIPTION[b].order;
    });
  }

  static isAvailableForDirectCheckoutPayout(currencyCode: string): boolean {
    return INTERNAL_PAYOUTS_SUPPORTED_CURRENCIES.indexOf(currencyCode) >= 0;
  }
}

export function supportedCurrenciesForAdyenPayouts(originCountryCode: string): string[] {
  const currencyToCountryMap: Record<string, string[]> = {
    GB: ['GBP', 'EUR'],
    SE: ['SEK', 'EUR'],
    DK: ['DKK', 'EUR'],
    PL: ['PLN', 'EUR'],
    HU: ['HUF', 'EUR'],
    CZ: ['CZK', 'EUR'],
    CH: ['CHF', 'EUR'],
    NO: ['NOK', 'EUR'],
  };

  return currencyToCountryMap[originCountryCode] || ['EUR'];
}

/**
 * Selling/listing supported currencies
 *
 * Some listing currencies are Payment Provider (PayPal or Reverb Payments) dependent
 */
export const LISTING_CURRENCIES = Object.freeze([
  'USD',
  'CAD',
  'EUR',
  'GBP',
  'AUD',
  'JPY',
  'NZD',
  'MXN',
]);

export const REVERB_PAYMENTS_EXPANSION_LISTING_CURRENCIES = Object.freeze([
  'SEK',
  'DKK',
  'PLN',
  'HUF',
  'CZK',
  'CHF',
  'NOK',
]);

/**
 * Supported for payouts by Reverb directly
*/
export const INTERNAL_PAYOUTS_SUPPORTED_CURRENCIES = Object.freeze([
  'USD',
  'CAD',
]);

export const ADYEN_SUPPORTED_CURRENCIES = Object.freeze([
  'EUR',
  'GBP',
]);

export const ADYEN_SUPPORTED_EXPANSION_CURRENCIES = Object.freeze([
  ...ADYEN_SUPPORTED_CURRENCIES,
  'SEK',
  'DKK',
  'PLN',
  'HUF',
  'CZK',
  'CHF',
  'NOK',
]);

export const PAYPAL_SUPPORTED_CURRENCIES = Object.freeze(LISTING_CURRENCIES);
